import { gql } from 'apollo-angular';

export const EmployeeFragmentDoc = gql`
  fragment Employee on Employee {
    id
    re
    name
    createdAt
    updatedAt
}
`;

export const GetEmployeeByReDocument = gql`
  query GetEmployeeByRe($re: String!) {
    getEmployeeRe(re: $re) {
      ...Employee
    }
  }
  ${EmployeeFragmentDoc}
`;